module.exports = __webpack_public_path__ + "static/media/bg_square-dark-1.99ba61fa.jpg";